import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

interface MarkPaidResponse {
  partnerId: string;
  monthsPaid: string[];
  totalAmount: number;
}

const markPartnerPayoutsPaidFn = httpsCallable<
  { partnerId: string; months?: string[] },
  MarkPaidResponse
>(functions, 'markPartnerPayoutsPaid');

export async function markPartnerPayoutsPaid(
  partnerId: string,
  months?: string[],
): Promise<MarkPaidResponse> {
  const result = await markPartnerPayoutsPaidFn({ partnerId, months });
  return result.data;
}
